import Jackpot from "../elements/Jackpots/HeaderV2";
import NewCounter from "../elements/Jackpots/NewCounter/index";
export const WinHistory = () => { return null };
export const JackpotCounter = NewCounter;
export { requestJackpots } from "../store/actions/jackpots";
export default Jackpot;